// Modules
import { useContext } from 'react'
import { Icon } from '@iconify/react'

//Utilities
import { personContext } from '../../utils/UtilContext'

const Departamento = ({ departamento }) => {
    const { loading, persons } = useContext(personContext)

    const departmantName = {
        cej : "Ciências Empresariais e Jurídicas",
        im : "Informática e Matemática",
        ah : "Artes e Humanidades"
    }

    let personsFilter = ((!loading || persons !== null) && Array.isArray(persons)) && 
        persons.filter((personsItem) => {
        return personsItem.servico.includes(departmantName[departamento]) && personsItem.estado.includes("Activo")
        })

    Array.isArray(persons) && personsFilter.sort((a, b) => a.nome.localeCompare(b.nome));

    if (loading) {
        return <Icon style={{fontSize: '3rem'}} icon="svg-spinners:ring-resize" />
    }

  return ( 
    <>
    <table className='departmentList'>
        <thead>
            <tr><th>Nome</th><th>Gabinete</th><th>Email</th><th>Extensão</th></tr>
        </thead>
        <tbody>
            {personsFilter.map((person, index) =>(
                <tr key={person.id} bgcolor={index%2 ? "CCCCCC" : "FFFFFF"}><td>{person.nome}</td><td>{person.porta}</td><td><a href={`mailto:${person.email}`}>{person.email}</a></td><td>{person.extensao}</td></tr>
            ))}
        </tbody>
    </table>
    </>
  )
}

export default Departamento
